<script lang="ts">
  let progress: HTMLSpanElement | null = $state(null);

  let completion: number = 0;
  const updateProgress = () => {
    const currentProgress: number = window.scrollY;
    let scrollHeight: number = document.body.scrollHeight - window.innerHeight;

    if (scrollHeight) {
      completion = parseFloat((currentProgress / scrollHeight).toFixed(2));
      completion *= 100;
      progress!.style.width = `${completion}%`;
    }
  };
</script>

<svelte:window onscroll={updateProgress} />

<span
  bind:this={progress}
  class="bg-gradient-colorful fixed top-0 h-1 animate-background border-none"></span>
